import { render, staticRenderFns } from "./bulk-message-attachment-warning-dialog.vue?vue&type=template&id=69c0aec0&scoped=true&"
import script from "./bulk-message-attachment-warning-dialog.vue?vue&type=script&lang=js&"
export * from "./bulk-message-attachment-warning-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c0aec0",
  null
  
)

export default component.exports